<template>
  <div :style="{ width: width }">
    <el-cascader v-if="isSelect" class="address-select" style="width: 100%" v-bind="$attrs" ref="cascaderRef"
      v-model="cascaderValue" :props="cascaderProps" />
    <div v-else class="address-select-text">
      {{ modelValue }}
      <button class="btn" @click="isSelect = true">修改</button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineEmits, defineProps, ref, watch, defineExpose, withDefaults, nextTick } from 'vue';
import type { CascaderProps, ElCascader } from 'element-plus';
// @ts-ignore
import { getQueryProv, getQueryCity, getQueryCoun } from '@/apis/modules/logistics';
const apiMap = { 0: getQueryProv, 1: getQueryCity, 2: getQueryCoun };
const nameMap = { 0: { name: 'nameProv', code: 'codeProv' }, 1: { name: 'nameCity', code: 'codeCity' }, 2: { name: 'nameCoun', code: 'codeCoun' } };

const props = withDefaults(defineProps<{ modelValue: string[] | string; width?: string; mode?: 'input' | 'select' }>(), { width: '100%', mode: 'select' });
const cascaderValue = ref<string[] | string>([]);
const isSelect = ref<boolean>(true);
const cascaderRef = ref<InstanceType<typeof ElCascader> | null>(null);
const cascaderProps: CascaderProps = {
  lazy: true,
  async lazyLoad(node, resolve) {
    const { level, value } = node;
    const nodeLevel = level as 0 | 1 | 2;
    if (level === 3) {
      return resolve([]);
    }
    try {
      const res = await apiMap[nodeLevel]({ code: value });
      if (res.statusCode === 20000) {
        resolve(res.data.map((item: any) => ({ label: item[nameMap[nodeLevel].name], value: item[nameMap[nodeLevel].code], leaf: level === 2 })));
      }
    } catch (error) {
      console.error('Error loading data:', error);
    }
  },
};

const getLabels = (separator: string = '') => {
  if (!cascaderRef.value) {
    return '';
  }

  const str = cascaderRef.value!.presentText;
  return str && str.length
    ? str
      .split('/')
      .map(item => item.trim())
      .join(separator)
    : str;
};

const emits = defineEmits<{ (e: 'update:modelValue', value: string[] | string): void }>();

watch(
  () => props.modelValue,
  (newValue: string[] | string) => {
    cascaderValue.value = newValue;
  },
);
watch(() => props.mode, (newValue) => {
  isSelect.value = newValue === 'select';
},
  { immediate: true })

watch(cascaderValue, (newValue: string[] | string) => {
  emits('update:modelValue', newValue);
});

defineExpose({ getLabels });
</script>

<style scoped lang="scss">
::v-deep .el-input__wrapper {
  background-color: #f2f2f2;
  height: 56px;
  border: none !important;
  box-shadow: none !important;

  &:hover {
    border: none !important;
    box-shadow: none !important;
  }
}

.address-select-text {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f2f2f2;
  height: 56px;
  border: none !important;
  box-shadow: none;
  padding: 0 24px;
  font-size: 14px;
  box-sizing: border-box;

  .btn {
    flex: 0 0 40px;
    margin-left: 10px;
    font-size: 14px;
  }
}
</style>
